import moment from 'moment'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { translate } from 'loankeeper-common/helpers'

import { maskForRequiredFields, DropdownNames } from '../constants'
import { isCheckboxSelected, isDateOfBirthBetween } from '../CashInOut/utils'

const ERR_REQUIRED_FIELD = translate('LKMESSAGE-ERR_REQUIRED_FIELD')

export const validate = (values, { requiredFields, OpenDay, cashOut, AgeLimitMin, AgeLimitMax }) => {
  const errors = {}

  if (cashOut) {
    if (!values.DebitChosenAccNo) {
      errors.DebitAccNo = ERR_REQUIRED_FIELD
    }
  } else if (!values.CreditChosenAccNo) {
    errors.CreditAccNo = ERR_REQUIRED_FIELD
  }

  if (values.DocDate && !LKDate.isValid(values.DocDate)) {
    errors.DocDate = 'invalid'
  }

  if (moment(values.IDCardRegDate, 'DD.MM.YYYY').isAfter(moment(OpenDay, 'DD.MM.YYYY'))) {
    errors.IDCardRegDate = 'invalid'
  }

  if (values.DOB && !LKDate.isValid(values.DOB)) {
    errors.DOB = 'invalid'
  }
  if (
    values.ClientType !== '3' &&
    isCheckboxSelected(values.DOBCheck) &&
    isDateOfBirthBetween(values.DOB, AgeLimitMin, AgeLimitMax)
  ) {
    errors.DOB = `year is beyond [${AgeLimitMin}, ${AgeLimitMax}]`
  }

  if (values.IDCardRegDate && !LKDate.isValid(values.IDCardRegDate)) {
    errors.IDCardRegDate = 'invalid'
  }

  if (values.ClientType !== '3' && values.IDValidityDate !== '-' && values.IDValidityDate !== '01.01.1900') {
    if (moment(values.IDValidityDate, 'DD.MM.YYYY').isBefore(moment(OpenDay, 'DD.MM.YYYY'))) {
      errors.IDValidityDate = 'invalid'
    }

    if (values.IDValidityDate && !LKDate.isValid(values.IDValidityDate)) {
      errors.IDValidityDate = 'invalid'
    }

    if (
      values.IDCardRegDate &&
      values.IDValidityDate &&
      moment(values.IDCardRegDate, 'DD.MM.YYYY').isAfter(moment(values.IDValidityDate, 'DD.MM.YYYY'))
    ) {
      errors.IDCardRegDate = 'invalid'
    }
  }

  if (values.fillClientDetailsWarning) {
    Object.keys(requiredFields).forEach((key) => {
      const fieldName = maskForRequiredFields[key]

      if (key !== 'IDValidityDate' || (key === 'IDValidityDate' && values.IDValidityDateCheck === '1')) {
        if (requiredFields[key].Active === 1) {
          if (!DropdownNames.includes(key)) {
            if (!values[fieldName]) {
              errors[fieldName] = ERR_REQUIRED_FIELD
            }
          } else if (parseInt(values[fieldName], 10) === 1) {
            errors[fieldName] = ERR_REQUIRED_FIELD
          }
        }
      }
    })
  }

  if (values.chosenAccountTypeID === 9) {
    if (values.MoneyTransferCountryID === 1) {
      errors.MoneyTransferCountryID = ERR_REQUIRED_FIELD
    }

    if (values.MoneyTransferSystemID === 1) {
      errors.MoneyTransferSystemID = ERR_REQUIRED_FIELD
    }

    if (!values.MoneyTransferCode) {
      errors.MoneyTransferCode = ERR_REQUIRED_FIELD
    }

    if (!values.MoneyTransferAgent) {
      errors.MoneyTransferAgent = ERR_REQUIRED_FIELD
    }
  }

  return errors
}
